
$('div .extra-option-checkbox').click(function () { 
  var checkedState = $(this).prop('checked');
  $('div.extra-options .extra-option-checkbox').each(function () {
    $(this).prop('checked', false);
    $(this).closest('.extra-option').removeClass('active');
  });
  $(this).prop('checked', checkedState);
  if (checkedState) {
    $(this).closest('.extra-option').addClass('active');
  }
});

$('div .additional-option-checkbox').click(function () { 
  $(this).closest('.additional-option').toggleClass('active');
});

$(document).on("click",".btn.product-add",function(event) {
  event.preventDefault();
  var id1 = parseInt($('#extra_option_1:checked').val());
  var id2 = parseInt($('#extra_option_2:checked').val());
  var id3 = parseInt($('#additional_option_1:checked').val());
  var id4 = parseInt($('#additional_option_2:checked').val());
  //console.log(id1);
  //console.log(id2);
  //console.log(id3);
  //console.log(id4);

  var data = {items: []};
  if( $('#extra_option_1:checked').val() != undefined ) {
  	data.items.push({quantity: 1, id: id1});
  }
  if( $('#extra_option_2:checked').val() != undefined ) {
  	data.items.push({quantity: 1, id: id2});
  }
  if( $('#additional_option_1:checked').val() != undefined ) {
  	data.items.push({quantity: 1, id: id3});
  }
  if( $('#additional_option_2:checked').val() != undefined ) {
  	data.items.push({quantity: 1, id: id4});
  }

  if (data.items.length > 0) {
    $.ajax({
      type: 'POST', 
      url: '/cart/add.js',
      dataType: 'json', 
      data: data,
      success: function(cart) {
        ajaxAddtoCart($('form.product-form')[0]);
      }
    });
  } else {
  	ajaxAddtoCart($('form.product-form')[0]);
  }
});

function ajaxAddtoCart($form_param) {
  var shopifyAjaxAddURL = theme.routes.cart_add_url + '.js';
  var shopifyAjaxCartURL = theme.routes.cart_url + '.js';

  var $form = $($form_param);
  var quantity = 1;
  var $quantity = $form.find('.qty-adjuster__value');

  if ($quantity.length) {
    quantity = $quantity.val();
  }

  // Disable add button
  $form.find(':submit').attr('disabled', 'disabled').each(function () {
    $(this).addClass('product-add--adding');
  });

  var $btns = $form.find(':submit');

  // add class to page
  theme.cartLoadingStarted();

  var serializedForm = $form.serialize();
  if (serializedForm.indexOf('quantity=') === -1) {
    serializedForm += "&quantity=".concat(quantity);
  }

  // Add to cart
  $.post(shopifyAjaxAddURL, serializedForm, function (itemData) {
    theme.utils.cookie.create('theme_added_to_cart', 'justnow', 1);

    // Update persistent cart summaries
    // enable add button
    $btns.each(function () {
      var $btn = $(this);
      setTimeout(() => {
        $btn.addClass('product-add--added').removeAttr('disabled');

        setTimeout(() => {
          $btn.removeClass('product-add--added').removeClass('product-add--adding');
        }, 2000);
      }, 500);
    }).first();

    theme.updateCartSummaries(
    $form.data('open-cart-drawer') || theme.settings.openCartDrawerOnMob && $(window).outerWidth() < 1100,
    true, !$form.hasClass('product-form--not-quickbuy'));

    if (!$form.data('open-cart-drawer')) window.location.href = '/cart';
  }, 'json').fail(function (data) {
    //Enable add button
    var $firstBtn = $form.find(':submit').removeAttr('disabled').each(function () {
      var $btn = $(this);
      var contentFunc = $btn.is('button') ? 'html' : 'val';
      $btn[contentFunc]($btn.data('previous-value'));
    }).first();

    //Not added, show message
    if (typeof data != 'undefined' && typeof data.status != 'undefined') {
      var jsonRes = $.parseJSON(data.responseText);
      theme.showQuickPopup(jsonRes.description, $quantity && $quantity.length ? $quantity : $firstBtn);
    } else {
      //Some unknown error? Disable ajax and submit the old-fashioned way.
      $form.attr('ajax-add-to-cart', 'false').submit();
    }

    //Reset the buttons
    $btns.each(function () {
      $(this).removeClass('product-add--adding');
    });
  }).always(function () {
    theme.cartLoadingFinished();
  });
}


function toggleExtraPopup(index) {
  var href = "#extra_option_modal_"+index;
  if (index == 'office') {
    $.colorbox({inline: true, href: href, width: "100%", maxWidth: "900px", onClosed: function () { $('body').toggleClass('modal-open'); }});
  } else {
    $.colorbox({inline: true, href: href, width: "100%", maxWidth: "600px", onClosed: function () { $('body').toggleClass('modal-open'); }});
  }
  $('body').toggleClass('modal-open');
}


const open = window.XMLHttpRequest.prototype.open;

function openReplacement() {
  this.addEventListener("load", function () {
    if (
      [
        "/cart/add.js",
        "/cart/update.js",
        "/cart/change.js",
        "/cart/clear.js",
      ].includes(this._url)
    ) {
      onCartUpdate(this.response);
    }
  });
  return open.apply(this, arguments);
}

window.XMLHttpRequest.prototype.open = openReplacement;

        
function onCartUpdate(cartJson) {
        
  console.log("onCartUpdate");
        
  var extraIDs = [42793239937280, 42793250849024, 42789179851008, 43091515343104];
      
  $.ajax({
        type: "get",
        url: "/cart.js",
        dataType: "json",
        async: false,
        cache: false,
        success: function(cart) {
        	totalCart = cart.items.length;
			
      		if ( totalCart == 0 ) return;
      
        	if (totalCart == 1 && $.inArray(cart.items[0].id, extraIDs) > -1) {
        		$.ajax({
                  type: "POST",
                  url: '/cart/clear.js',
                  success: function(){
                    console.log('You cleared the cart!');
                    window.location.reload();
                  },
                  dataType: 'json'
                });
              	
            } else if (totalCart == 2 && ($.inArray(cart.items[0].id, extraIDs) > -1 && $.inArray(cart.items[1].id, extraIDs) > -1)) {
            	$.ajax({
                  type: "POST",
                  url: '/cart/clear.js',
                  success: function(){
                    console.log('You cleared the cart!');
                    window.location.reload();
                  },
                  dataType: 'json'
                });
              	
            } else if (totalCart == 3 && ($.inArray(cart.items[0].id, extraIDs) > -1 && $.inArray(cart.items[1].id, extraIDs) > -1 && $.inArray(cart.items[2].id, extraIDs) > -1)) {
            	$.ajax({
                  type: "POST",
                  url: '/cart/clear.js',
                  success: function(){
                    console.log('You cleared the cart!');
                    window.location.reload();
                  },
                  dataType: 'json'
                });
              	
            } else if (totalCart == 4 && ($.inArray(cart.items[0].id, extraIDs) > -1 && $.inArray(cart.items[1].id, extraIDs) > -1 && $.inArray(cart.items[2].id, extraIDs) > -1 && $.inArray(cart.items[3].id, extraIDs) > -1)) {
            	$.ajax({
                  type: "POST",
                  url: '/cart/clear.js',
                  success: function(){
                    console.log('You cleared the cart!');
                    window.location.reload();
                  },
                  dataType: 'json'
                });
              	
            } else {
            	var hasMacbook = false;
              	for(var i = 0; i < cart.items.length; i++) {
                  console.log(cart.items[i].product_type);
                  if (cart.items[i].product_type.toLowerCase().indexOf("macbook") >= 0) {
                  	var hasMacbook = true;
                  }
                }
            
              	if (!hasMacbook) {
                	const data = {
                    	items: [
                    		{
                    			quantity: 0,
                    			id: 42789179851008
                    		},
                    		{
                    			quantity: 0,
                    			id: 43091515343104
                    		}
                    	]
                    };
                  
                    jQuery.ajax({
                        type: 'POST',
                        url: '/cart/change.js',
                        data: data,
                        dataType: 'json',
                        success: function() { 
                          console.log('success!');
                          window.location.reload();
                        }
                    });
                  	
                } else {
                  
                }
            }
        }
  });
}

$(document).scroll(function () {
  if($(".sticky-add-to-cart").length) {
    if ($(this).scrollTop() > 500) { 
      $(".sticky-add-to-cart").addClass("active");
    }else{
      $(".sticky-add-to-cart").removeClass("active");
    }
  }
});

$('a.live-chat').click(function (event) { 
  event.preventDefault();
  window.Tawk_API.toggle();
});


